import { render, staticRenderFns } from "./OutlookConnectComingSoon.vue?vue&type=template&id=2d920cea&scoped=true&lang=pug"
var script = {}
import style0 from "./OutlookConnectComingSoon.vue?vue&type=style&index=0&id=2d920cea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d920cea",
  null
  
)

export default component.exports